// extracted by mini-css-extract-plugin
module.exports = {"modalCarousel":"styles_modalCarousel__FTC6b","modalSwiper":"styles_modalSwiper__3Drkb"};